import { Store } from '@/core/store/core.store';
import { _APP_STORE } from '../enums/app.enum';
import { _APP_STORE as _APP_STORE_CORE } from '@/core/values/app.values';
import { IMemberPosition } from '../interfaces/member-position.interface';

export class AppStoreFacade {

  async getInitialData() {
    return Store.dispatch(_APP_STORE.GET_INITIAL_DATA);
  }

  async updateUserPosition(args:{sectionId: number, courseId: number, classId: number, homeworkId:number}) {
    return Store.dispatch(_APP_STORE_CORE.ACTIONS.SEND_TEACHER_POSITION, args);
  }

  async cleanUserPosition() {
    return Store.dispatch(_APP_STORE_CORE.ACTIONS.CLEAN_TEACHER_POSITION);
  }

  setFileExtNotAllowed(extensions: string[]) {
    Store.commit(_APP_STORE.SET_FILE_EXT_NOT_ALLOWED, extensions);
  }

  setInstitutionsLoaded(value: boolean) {
    Store.commit(_APP_STORE.SET_INSTITUTIONS_LOADED, value);
  }

  setActiveSchoolDaysLoaded(value: boolean) {
    Store.commit(_APP_STORE.SET_ACTIVE_SCHOOL_DAYS_LOADED, value);
  }

  setCopyrightsColor(color: string) {
    Store.commit(_APP_STORE.SET_COPYRIGHTS_COLOR, color);
  }

  changeRouter(usingRouter: boolean) {
    Store.commit(_APP_STORE.CHANGE_ROUTER, usingRouter);
  }

  toggleSidebar() {
    Store.commit(_APP_STORE.TOGGLE_SIDEBAR);
  }

  showSidebar() {
    Store.commit(_APP_STORE.SHOW_SIDEBAR);
  }

  changeFooterType(type: string) {
    Store.commit(_APP_STORE.CHANGE_FOOTER_TYPE, type);
  }

  setHeaderVisible(visible: boolean) {
    Store.commit(_APP_STORE.SET_HEADER_VISIBLE, visible);
  }

  setActiveWebwiew(active: boolean) {
    Store.commit(_APP_STORE.SET_ACTIVE_WEBVIEW, active);
  }

  setMemberPosition(data: IMemberPosition) {
    Store.commit(_APP_STORE.SET_MEMBER_POSITION, data);
  }

  setSocketConnected(value: boolean) {
    Store.commit(_APP_STORE.SET_SOCKET_CONNECTED, value);
  }

  setPresentationSocketConnected(value : boolean){
    Store.commit(_APP_STORE.SET_PRESENTATION_SOCKET_CONNECTED, value);
  }

  addErrorLogs(errorLog : any){
    Store.commit(_APP_STORE.ADD_ERROR_LOG, errorLog);
  }

  cleanErrorLogs() {
    Store.commit(_APP_STORE.CLEAN_ERROR_LOG);
  }

  setUserMode(value: string){
    Store.commit(_APP_STORE.SET_USER_MODE, value);
  }

  updatePreviousDisconnectionSocket(isPreviousDisconnectionSocket : boolean){
    Store.commit(_APP_STORE.UPDATE_PREVIOUS_DISCONNECTION_SOCKET, isPreviousDisconnectionSocket);
  }

  setSidebarButton(value: boolean) {
    Store.commit(_APP_STORE.SET_SIDEBAR_BUTTON, value);
  }

  setAppReady(value: boolean) {
    Store.commit(_APP_STORE.SET_APP_READY, value);
  }

  updateBoardPreviousDisconnectionSocket(isBoardPreviousDisconnectionSocket : boolean){
    Store.commit(_APP_STORE.UPDATE_BOARD_PREVIOUS_DISCONNECTION_SOCKET, isBoardPreviousDisconnectionSocket);
  }

  setSubjectBuilderActive(value: boolean) { 
    Store.commit(_APP_STORE.SET_SUBJECT_BUILDER_ACTIVE, value);
  }
}